var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        "div",
        {
          staticClass: "screen-mode-and-save justify-content-end",
          class: { "screen-mode-and-save-scroll": _vm.isScroll }
        },
        [
          _c("div", { staticClass: "wrap-screen-mode justify-content-end" }, [
            _c(
              "button",
              { staticClass: "save-button", on: { click: _vm.submitForm } },
              [_vm._v("\n        Save\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-page" }, [
        _c("div", { staticClass: "icon-code-editor" }, [
          _c("img", {
            attrs: { src: require("@/assets/new-form-ui/code-editor.svg") },
            on: { click: _vm.openModalCodeEditor }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "tooltip-component" }, [
            _vm._v("\n        Code Editor\n      ")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "icon-setup-view",
            class: {
              "error-input":
                _vm.$v.dataSetup.column.title.$error ||
                _vm.$v.dataSetup.column.description.$error ||
                _vm.$v.dataSetup.column.color.$error ||
                _vm.$v.dataSetup.column.start_date_time.$error ||
                _vm.$v.dataSetup.column.end_date_time.$error
            },
            on: { click: _vm.openConfiguration }
          },
          [
            _c("img", {
              attrs: { src: require("@/assets/new-form-ui/setup.svg") }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "tooltip-component" }, [
              _vm._v("\n        Configuration\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-page-title card-page-title-white" },
          [
            _c("b-form", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.dataSetup.title,
                    expression: "dataSetup.title"
                  }
                ],
                staticClass: "input-title",
                class: { "error-input": _vm.$v.dataSetup.title.$error },
                attrs: { type: "text", placeholder: "Enter title here" },
                domProps: { value: _vm.dataSetup.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.dataSetup, "title", $event.target.value)
                  }
                }
              })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-page-content pt-3" },
          [
            _c(
              "div",
              { staticClass: "d-flex align-items-center mb-2" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn grey btn-import-form m__r--5",
                    attrs: { disabled: "" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus fa-lg" }),
                    _vm._v(" Add\n        ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "btn grey btn-import-form m__r--5",
                    attrs: { disabled: "" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-cloud-upload fa-lg" }),
                    _vm._v(" Import\n        ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "btn grey btn-import-form m__r--5",
                    attrs: { disabled: "" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-download fa-lg" }),
                    _vm._v(" Export\n        ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "btn grey btn-import-form m__r--5",
                    attrs: { id: "filterPopover" },
                    on: {
                      click: function($event) {
                        _vm.showPopover = true
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-filter fa-lg" }),
                    _vm._v(" Filter\n        ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.isLoading
              ? _c("j-skeleton-calendar")
              : _c("j-calender-view-widget", {
                  attrs: {
                    "form-data": _vm.formData,
                    "form-ui": _vm.formUi,
                    "use-title": false
                  }
                })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-transparent m__t--15" }, [
        _vm.formDetail.calendar_view
          ? _c(
              "span",
              {
                staticClass: "cursor-pointer",
                staticStyle: { "font-size": "14px" },
                on: { click: _vm.deleteView }
              },
              [
                _c("i", { staticClass: "fa fa-trash" }),
                _vm._v(" "),
                _c("small", [_vm._v("Delete this view")])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          attrs: {
            show: _vm.showPopover,
            target: "filterPopover",
            container: "newExperienceManager",
            triggers: "click blur",
            placement: "bottom"
          },
          on: {
            "update:show": function($event) {
              _vm.showPopover = $event
            }
          }
        },
        [
          _c("popup-filter", {
            attrs: { filters: _vm.dataSetup.search_options_list }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isOpenConfiguration
        ? _c("calendar-configuration", {
            attrs: {
              id: _vm.idConfiguration,
              "data-config": _vm.dataSetup,
              "list-function": _vm.listFunction,
              variables: _vm.optionVariables
            },
            on: {
              "close-configuration": function($event) {
                _vm.toggleConfiguration(false)
              },
              submit: _vm.submitConfig
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showModalFieldLibrary
        ? _c("modal-field-library", {
            on: { "close-modal": _vm.closeModalFieldLibrary }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalExternalApi",
          staticClass: "modal-external-api",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [_vm.showModalExternalUrl ? _c("modal-external-api-field") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalCodeEditor",
          staticClass: "modal-code-editor-wrap",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.showModalCodeEditor
            ? _c("modal-code-editor", {
                attrs: {
                  "view-data": _vm.viewJsonData,
                  "view-title": "Calendar View",
                  type: "calendar_view"
                },
                on: {
                  close: _vm.closeModalCodeEditor,
                  update: _vm.updateViewByCode
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f25032b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f25032b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/menu/jCalendarView.vue
// module id = null
// module chunks = 